module.exports = __webpack_public_path__ + "media/images/arrows-26db36bd8e93d94bc99d3a0f68b6ab68.svg";